import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import withBackend from '../../backend/withBackend';
import { setUser } from '../../actions';
import AdminDashboard from '../../components/AdminDashboard';

class AdminDashboardContainer extends Component {
  onFetchUser = () => {
    const { firebase, setUser: setUserAction } = this.props;
    const uid = firebase.auth.currentUser?.uid;
    if (!uid) {
      return;
    }
    firebase
      .getUser(uid)
      .then((snapshot) => setUserAction(snapshot.data()))
      .catch((error) => console.error(error));
  };

  render() {
    const { firebase, user } = this.props;
    return (
      <AdminDashboard
        firebase={firebase}
        userData={user}
        onFetchUser={this.onFetchUser}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
});

export default compose(connect(mapStateToProps, { setUser }), withBackend)(AdminDashboardContainer);
